export default __webpack_public_path__ + "static/media/cases4@2x.0fd629ab.jpg";